import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";

interface ProdutoBasico {
  id:        number;
  descricao: string;
}

/**
 * Exibe "[código] descrição" de um produto a partir do ID — para tabelas cujo DTO
 * só traz `produtoId`. Compartilha o cache ["produto", id] do ProdutoSearchCombobox.
 */
export function ProdutoNome({ id }: { id?: number | null }) {
  const { data } = useQuery({
    queryKey: ["produto", id],
    queryFn:  async () => (await apiClient.get<ProdutoBasico>(`/api/produtos/${id}`)).data,
    enabled:  !!id,
    staleTime: 60_000,
  });

  if (!id) return <span className="text-muted-foreground">—</span>;
  return (
    <span>
      <span className="text-muted-foreground">[{id}]</span>{" "}
      {data?.descricao ?? "…"}
    </span>
  );
}
